import React, { useState, useEffect } from "react";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  createNotebook,
  getAllNotebooks,
  deleteNotebook,
  UpdateNotebook,
} from "src/apis/notebook_apis";
import { useAlertContext } from "src/hooks/use-alert";
import "./notebook.css";
import { defer,useRouteLoaderData } from "react-router-dom";

const Notebook = () => {
  const alert = useAlertContext();
  const [notebook, setNotebook] = useState([]);
  const [showAddNewNote, setShowAddNewNote] = useState(false);
  const [newNoteTitle, setNewNoteTitle] = useState("");
  const [newNoteDescription, setNewNoteDescription] = useState("");
  const [openNotebook, setOpenNotebook] = useState(false);
  const [selectedNotebookId, setSelectedNotebookId] = useState(null);
  const [notebookDialogStates, setNotebookDialogStates] = useState({});
  const [editedTitle, setEditedTitle] = useState("");
  const [editedDescription, setEditedDescription] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const allNotes = useRouteLoaderData("notebook");

  const handleOpenAddNewNote = () => {
    setShowAddNewNote(true);
  };

  const handleClose = () => {
    setShowAddNewNote(false);
  };

  const handleOpenEditDialog = (note) => {
    setEditedTitle(note.Title);
    setEditedDescription(note.Description);
    setSelectedNotebookId(note.id);
    setEditDialogOpen(true);
  };

  const handleSaveEdit = async () => {
    try {
      const response = await UpdateNotebook(selectedNotebookId, {
        contenuto: editedDescription,
        titolo: editedTitle,
      });

      if (response.success) {
        // Update the notebook state with the edited title and description
        const updatedNotes = notebook.map((note) =>
          note.id === selectedNotebookId
            ? { ...note, Title: editedTitle, Description: editedDescription }
            : note
        );

        setNotebook(updatedNotes);

        // Reset editing state and clear edited fields
        setEditDialogOpen(false);
        setEditedTitle("");
        setEditedDescription("");

        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Notebook added succesfully",
            index: prev.length,
          },
        ]);
      } else {
        console.log(response);
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelEdit = () => {
    setEditDialogOpen(false);
    setEditedTitle("");
    setEditedDescription("");
  };

  const refreshNotes = async () => {
    try {
      const allNotes = await getAllNotebooks();

      if (allNotes) {
        console.log(allNotes);

        const formattedNotes = allNotes.map((note) => ({
          id: note.id,
          Title: note.titolo,
          Description: note.contenuto,
          date: new Date().toString(),
        }));

        setNotebook(formattedNotes);
        console.log(formattedNotes);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    refreshNotes();
  }, []);

  const MAX_DESCRIPTION_LENGTH = 2000;
  const handleAddNewNote = async (event) => {
    event.preventDefault();

    // Validate that required fields are not empty
    if (!newNoteTitle || !newNoteDescription) {
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          message:
            "Please fill in all required fields (Title, Priority, Expire Date, End Repetition).",
        },
      ]);
      return;
    }

    // Validate description length
    if (newNoteDescription.length > MAX_DESCRIPTION_LENGTH) {
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          message: `Description must not exceed ${MAX_DESCRIPTION_LENGTH} characters.`,
        },
      ]);
      return;
    }

    const newNote = {
      contenuto: newNoteDescription,
      titolo: newNoteTitle,
    };

    try {
      const response = await createNotebook(newNote);

      if (response) {
        // Add the new task to the tasks state
        const formattedNewNote = {
          id: response.id, // Assuming the response contains the ID of the newly created notebook
          Title: newNote.titolo,
          Description: newNote.contenuto,
          date: new Date().toString(),
        };

        setNotebook([...notebook, formattedNewNote]);
        setNewNoteTitle("");
        setNewNoteDescription("");
        setShowAddNewNote(false);

        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Notebook added succesfully",
            index: prev.length,
          },
        ]);
      } else if (response && response.errors) {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      } else {
        console.error("Invalid response from createNote:", response);
      }
    } catch (error) {
      console.error("Error in handleAddNote:", error);
    }
  };

  const handleNewNoteDescriptionChange = (event) => {
    setNewNoteDescription(event.target.value);
  };

  const handleNewNoteTitleChange = (event) => {
    setNewNoteTitle(event.target.value);
  };

  const handleOpenNotebook = (id) => {
    setNotebookDialogStates({
      ...notebookDialogStates,
      [id]: true,
    });
    setSelectedNotebookId(id);
  };

  const handleClosed = (id) => {
    // Set the selected notebook's dialog state to false
    setNotebookDialogStates({
      ...notebookDialogStates,
      [id]: false,
    });
    setOpenNotebook(false);
  };

  async function DeleteNote(id) {
    const response = await deleteNotebook(id);
    return response;
  }

  const deleteNotebookFromComponent = async (note) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Notebook?"
    );
    if (confirmDelete) {
      console.log(note);
      console.log(note.id);

      try {
        // Delete the notebook on the server
        const response = await DeleteNote(note.id);

        if (response.success) {
          console.log(response);

          // Update the notebook state by filtering out the deleted notebook
          const updatedNotes = notebook.filter((item) => item.id !== note.id);

          setNotebook(updatedNotes);

          setOpenNotebook(false);

          alert.setSuccess((prev) => [
            ...prev,
            {
              status: true,
              message: "Notebook deleted succesfully",
              index: prev.length,
            },
          ]);
        } else {
          console.log(response);
          alert.setError((prev) => [
            ...prev,
            { status: true, messages: response.errors, index: prev.length },
          ]);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div className="notebookContainer">
      <h2>Notebook</h2>
      <Grid container>
        <Grid item md={3} lg={3} sm={6} xs={12}>
          <div className="cardHolder">
            <div className="addNewNote">
              <ButtonPolicy onClick={handleOpenAddNewNote}>+</ButtonPolicy>
            </div>
          </div>
        </Grid>

        {notebook.length > 0 ? (
          notebook.map((note) => (
            <>
              <Grid item md={3} lg={3} sm={6} xs={12} key={note.id}>
                <div className="cardHolder">
                  <div className="noteLeft"></div>
                  <div
                    className="noteCard"
                    onClick={() => handleOpenNotebook(note.id)}
                  >
                    <p>{note.Title}</p>
                    <p>{note.Description}</p>
                    <p>{note.date ? note.date.toString() : ""}</p>
                  </div>
                </div>
              </Grid>
              {/* //Dialog to show each note book details// */}
              <Dialog
                open={notebookDialogStates[note.id] || false}
                onClose={() => handleClosed(note.id)}
              >
                {selectedNotebookId === note.id && (
                  <>
                    <DialogTitle>
                      <div className="NoteTitle">{note.Title}</div>
                    </DialogTitle>
                    <DialogContent>
                      <div className="NoteDescription">{note.Description}</div>
                      <div className="NoteDescription">
                        {note.date ? note.date.toString() : ""}
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <ButtonPolicy
                        className="closeAddNoteButton"
                        onClick={() => handleClosed(note.id)}
                      >
                        Close
                      </ButtonPolicy>
                      <ButtonPolicy
                        className="addNoteBookButton"
                        onClick={() => deleteNotebookFromComponent(note)}
                      >
                        Delete
                      </ButtonPolicy>
                      <ButtonPolicy
                        className="addNoteBookButton"
                        onClick={() => handleOpenEditDialog(note)}
                      >
                        Edit
                      </ButtonPolicy>
                    </DialogActions>
                  </>
                )}
              </Dialog>
            </>
          ))
        ) : (
          <p>There is not any Notebook yet.</p>
        )}
        <>
          {/* //Dialog to edit a Notebook// */}
          <Dialog
            open={editDialogOpen}
            onClose={handleCancelEdit}
            maxWidth="md"
          >
            <DialogTitle>Edit Notebook</DialogTitle>
            <DialogContent>
              <form>
                <div className="NoteTitle">
                  <input
                    placeholder="Title"
                    required
                    type="text"
                    value={editedTitle}
                    onChange={(e) => setEditedTitle(e.target.value)}
                  />
                </div>
                <div className="NoteDescription">
                  <textarea
                    placeholder="Description"
                    required
                    type="text"
                    cols="40"
                    multiline
                    value={editedDescription}
                    onChange={(e) => setEditedDescription(e.target.value)}
                  />
                </div>
              </form>
            </DialogContent>
            <DialogActions>
              <ButtonPolicy
                className="closeAddNoteButton"
                onClick={handleCancelEdit}
              >
                Cancel
              </ButtonPolicy>
              <ButtonPolicy
                className="addNoteBookButton"
                onClick={handleSaveEdit}
              >
                Save
              </ButtonPolicy>
            </DialogActions>
          </Dialog>

          {/* //Dialog to aad a new Notebook// */}
          <Dialog
            open={showAddNewNote}
            onClose={() => setShowAddNewNote(false)}
          >
            <DialogTitle>Add New Notebook</DialogTitle>
            <div className="cover">
              <DialogContent>
                <form onSubmit={handleAddNewNote}>
                  <div className="NoteTitle">
                    <input
                      placeholder="Title"
                      id="noteTitle"
                      required
                      type="text"
                      value={newNoteTitle}
                      onChange={handleNewNoteTitleChange}
                    />
                  </div>
                  <div className="NoteDescription">
                    <textarea
                      placeholder="Description"
                      id="noteDescription"
                      required
                      type="text"
                      cols="40"
                      multiline
                      value={newNoteDescription}
                      onChange={handleNewNoteDescriptionChange}
                    />
                  </div>
                </form>
              </DialogContent>
              <DialogActions>
                <ButtonPolicy
                  className="closeAddNoteButton"
                  onClick={handleClose}
                >
                  Close
                </ButtonPolicy>
                <ButtonPolicy
                  className="addNoteBookButton"
                  onClick={handleAddNewNote}
                >
                  Add
                </ButtonPolicy>
              </DialogActions>
            </div>
          </Dialog>
        </>
      </Grid>
    </div>
  );
};

export default Notebook;


async function loadNotebooks() {
  const response = await getAllNotebooks();
  return response;
}

export async function loader() {
  return defer({
    notebook: await loadNotebooks(),
  });
}
